import React from "react";
import SideEffects from "./side-effects";

// Wrapper for Q17 in the kept GLP-1 follow-up pathway.
export default function Step17(props) {
  return <SideEffects {...props} nextStepId="18" />;
}
